export default __webpack_public_path__ + "logo-tuv-2e44eb2a94f89cd9c3b81fd01a6b981f.svg";